"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _markdown = _interopRequireDefault(require("../markdown"));

require("./media-card.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * UI for Card
 * If passed onClick, will be tabbable and clickable.
 */
var MediaCard = function MediaCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      image = _ref.image,
      text = _ref.text,
      title = _ref.title,
      onClick = _ref.onClick;
  return _react["default"].createElement("div", {
    role: "button",
    tabIndex: "0",
    className: "MediaCard ".concat(className),
    onClick: onClick,
    onKeyPress: onClick
  }, _react["default"].createElement("div", {
    className: "card-image"
  }, _react["default"].createElement("img", {
    src: image.src,
    alt: image.alt
  })), _react["default"].createElement("div", {
    className: "card-content"
  }, _react["default"].createElement("h3", {
    className: "card-title"
  }, title), _react["default"].createElement(_markdown["default"], {
    source: text
  }), children));
};

MediaCard.propTypes = {
  image: _propTypes["default"].shape({
    src: _propTypes["default"].string,
    alt: _propTypes["default"].string
  }),
  title: _propTypes["default"].string,
  text: _propTypes["default"].string,
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  children: _propTypes["default"].node
};
MediaCard.defaultProps = {
  image: {},
  title: null,
  text: null,
  className: '',
  onClick: null,
  children: null
};
var _default = MediaCard;
exports["default"] = _default;